import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { ExpenseDTO, ExpensesMode } from './useExpensesQuery';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

export const SAVE_EXPENSES_MK = ['saveExpensesMutation'];

interface FetcherParams {
  clientId: string;
  expensesInputMode: ExpensesMode;
  totalExpenses?: Partial<ExpenseDTO>;
  detailedExpenses?: Partial<ExpenseDTO>[];
}

const saveExpenses = ({
  clientId,
  expensesInputMode,
  totalExpenses,
  detailedExpenses,
}: FetcherParams): Promise<null> => {
  return authFetch('/Consumer/ExpenseUpdate/Save', {
    method: 'POST',
    ...httpBodyOptions({ clientId, expensesInputMode, totalExpenses, detailedExpenses }, true),
  });
};

interface MutationParams {
  clientId: string;
}

export const useSaveExpensesMutation = ({ clientId }: MutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(saveExpenses, {
    mutationKey: SAVE_EXPENSES_MK,
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.expenses(clientId));
    },
  });
};
